define( [
	"./deletedIds"
], function( deletedIds ) {
	return deletedIds.slice;
} );



// WEBPACK FOOTER //
// ./~/jquery/src/var/slice.js